import React from "react";
import styles from "./WorksBody.module.css";

const WorksBody = () => {
  return (
    <div className={styles.entireWorksBody}>
      <div className={styles.worksBodyContainer}>
        {/* Intro / Key Outcomes */}
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            ✨ Key Features
          </h2>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Cannabis menu aggregator — pulls products from hundreds of
                stores across multiple POS systems and displays them in one
                clean interface.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Unified product model (name, brand, type, weights, prices,
                THC/CBD, terpenes) as normalized output from wildly varying
                schema inputs; enables easy comparison.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Location-aware browsing — search by ZIP and radius, then filter
                by category (flower, vapes, concentrates, etc.), cannabis type
                (indica, sativa, etc.), weight, brand, THC, price, and
                dispensary location; then sort by name, brand, price, THC
                content, or weight.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Product detail modal shows potency & top terpenes. Opening it
                triggers on-demand enrichment that patches the DB; subsequent
                views show the enriched snapshot. Includes a direct “Open in
                Store” link.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Users can save products to a purchased list and wishlist tied to
                their account, recording price deltas and availability to alert
                users to price drops and restocks.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Daily refresh pipeline that ingests 120,000+ items in minutes.
              </span>
            </p>
          </div>
        </div>

        {/* Buyer / Patient Experience */}
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            👥 Patient & Buyer Experience
          </h2>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Mobile-first UI with infinite scrolling and quick, intuitive
                filters — fast to find exactly what users need and compare
                options.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Clear, weight-specific pricing (e.g., gram, eighth, half) and
                easy brand/strain search for granular filtering on tens of
                thousands of products.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Modal detail view shows potency, top terpenes, and a quick store
                link — Greenhub opens no new tabs until the user chooses to
                visit the dispensary site to order.
              </span>
            </p>
          </div>
        </div>

        {/* How it works (lite) */}
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            ⚙️ How It Works (At a Glance)
          </h2>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Scraper engine fetches public menu data from major platforms —
                then normalizes it into a single dataset.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Next.js app reads that data and lets users filter and sort
                thousands of products within a given radius. Selecting a product
                opens a modal with details and a direct link to order on the
                store site.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                On-demand enrichment fills in terpene data when a user opens a
                product, so you see the info that matters without slowing the
                main browse experience. The data is saved for future views and
                analytics.
              </span>
            </p>
          </div>
        </div>

        {/* Implementation touchpoints (kept light) */}
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            🏗️ Architecture & Data Flow
          </h2>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Next.js full-stack frontend on a custom-hardened VPS with an
                adjacent PostgreSQL database for low-latency reads and
                predictable costs.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Custom scraper engine pulls and normalizes hundreds of thousands
                of products every day for a convenient browsing and selection
                experience.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                ZIP-to-lat/lon lookups enable radius filtering; rate-limiting,
                JWT authentication, and API header secrets protect APIs and keep
                costs predictable.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Defensive WebP conversion and image fallbacks, plus
                duplicate-entry protection, ensure stable browsing.
              </span>
            </p>
          </div>
        </div>

        {/* Data Quality & Reliability */}
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            🛡️ Data Quality & Reliability
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Composite unique key prevents dupes (product_id + amount +
                store_id) and keeps results clean.
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Terpene fallbacks: labs first; if missing, parse structured data
                in descriptions to recover top terps.
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Image proxy & graceful fallbacks to avoid broken thumbnails
                across vendors.
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Abuse protection: IP rate-limits and caching keep the API
                responsive and costs in check.
              </span>
            </p>
          </div>
        </div>

        {/* Problem solving */}
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            🧠 Problem Solving
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Some providers don’t expose terpenes in bulk menu APIs (or
                render them dynamically). I solved this three ways: targeted
                follow-up requests via product endpoints, a lightweight
                headless-browser step for JS-hydrated pages, and batched
                requests for platforms with “smart paging” to ensure full
                coverage.
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                I used DevTools and Flame Charts to discover and correct
                inefficiencies in rendering flows, increasing performance by
                well over 1000%.
              </span>
            </p>
          </div>
        </div>

        {/* Why it matters */}
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            📈 Why This Matters
          </h2>
          <p className={styles.worksBodyKeyPointsDetail}>
            Greenhub helps patients and shoppers compare the market quickly —
            not just price, but also potency and terp profiles — across many
            dispensaries in one place. In medical cannabis programs, it’s
            important (and often difficult) for patients to find what works best
            for them.
          </p>
          <p className={styles.worksBodyKeyPointsDetail}>
            With so many products spread across so many stores — each with
            rotating inventory — it can be difficult to find what you're looking
            for. Greenhub is designed to be fast and easy today and ready for
            deeper analytics and user features tomorrow.
          </p>
        </div>

        {/* Roadmap */}
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>🚀 Roadmap</h2>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Historical database & analytics (price history, terp trends,
                product lifespans).
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                CMS for content (education, store spotlights) and a design
                polish pass with the brand system.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Purchased list and review options to provide product
                recommendations.
              </span>
            </p>
          </div>

          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>Terpene searches, sorts, and filters.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorksBody;
